
class MealPlan {

  constructor(product_id,moneyFormat,formselector,activeday,activemealtype) {
    console.log('script-started');
    this.product = JSON.parse($("#json-data-"+product_id).html());
    this.moneyFormat = moneyFormat;
    this.formselector = formselector;
    this.mealtypes = this.oldmealtype = activemealtype;
    
    this.mealday = activeday;
    //this.isFreeBreakfast = isbreakfast;
    this.variants ={};
    $(this.formselector).find("input[name='data-mealtype[]']").bind('change', this.onChangeMealtype.bind(this));
    //$(this.formselector).find("input:checkbox[name=addon_productid]").bind('change', this.updateAddonProducts.bind(this));   
    $(this.formselector).find("input:checkbox[name='addon_productid[]']").bind('change', this.updateAddonProducts.bind(this));
    $(this.formselector).find("input:checkbox[name='addon_productid[]']").bind('change', this.updatePriceValues.bind(this));
    $(this.formselector).find("input:checkbox[name=bag_deposit]").bind('change', this.updatePriceValues.bind(this));
    //$(this.formselector).find("input[name='properties[Which days of the week?]']").bind('change', this.onChangeDay.bind(this));
    $(this.formselector).find("input[name='days']").bind('change', this.onChangeDays.bind(this));
    $(this.formselector).find("#button-"+this.product.id).bind('click', this.validateAddOnProducts.bind(this));
    $(this.formselector).find("#stricky-button-"+this.product.id).bind('click', this.validateAddOnProducts.bind(this));
    /*if ($(window). width() < 480) {
   		 $(this.formselector).find(".program-tab ul li").bind('click', this.onChangeTab.bind(this));
    }*/
    this.prepareVariantData();
    this.selectVariant();
    //this.onChangeDay();
    this.onChangeDays();
    $('.error').html('');
//     console.log(this.cart());
  }
  onChangeTab(c){
  	 //console.log($(c.currentTarget).hasClass('active'));
    if($(c.currentTarget)&&!$(c.currentTarget).hasClass('active')){ //this is the start of our condition 
        
        $(this.formselector).find(".program-tab ul li").removeClass('active');           
        $(c.currentTarget).addClass('active');
		$(this.formselector).find(".length-program").addClass('d-none-m');
        $('#'+ $(c.currentTarget).data('id')).removeClass('d-none-m').fadeIn('slow');
     }
  }
  validateAddOnProducts(){
    $('.error').html('');
    var self=this;
	var formData = new FormData($(this.formselector)[0]);
    var id= formData.get('id');
    var startdate=formData.get('properties[Start Date]');
    var howmanydays=formData.get('properties[Which days of the week?]');
    var slot=formData.get('properties[Preferred Delivery Slot]');
    var addonformData = new FormData();

//     console.log(formData);console.log(formData.get('items'));
    var addonitems=[];
    var properties={};
    if(startdate!=''){
//        console.log(startdate); 
     	 properties['Start Date']=startdate;
    }else{
      $('.error').html('Please select start date');
      $('input[name="properties[Start Date]"]').focus();
       return false;  
    }
    if(slot!=''){
//         console.log(slot);
     	 properties['Preferred Delivery Slot']=slot;
    }
    if(howmanydays!=''){
//         console.log(slot);
     	 properties['Which days of the week?']=howmanydays;
    }
    if(id!=''){
      var main={'quantity':1,'id':id};
       if(Object.keys(properties).length>0){
           main['properties']=properties;
        }
     	addonitems.push(main); 
//         self.cartClear();
    }
   
    $(this.formselector).find("input:checkbox[name='addon_productid[]']:checked").each(function(){
       addonformData.append('quantity',parseInt(self.mealday));
       addonformData.append('id',$(this).val());
       addonitems.push({'quantity':parseInt(self.mealday),'id':$(this).val()});
      console.log("addonitems");
      console.log(addonitems);
    });
    if(parseInt($(this.formselector).find('input:checkbox[name=bag_deposit]:checked').val())>0){
      addonitems.push({'quantity':1,'id':$(this.formselector).find('input:checkbox[name=bag_deposit]:checked').val()});
    }
    
    if(addonitems.length>0){
//       self.cartClear().then(response1 => {
       let formData = {
           'items': addonitems
          };
        var returndata = this.cartAddFromForm(formData).then(response => {
//           console.log(response);
       		 window.location.replace("/cart");
          return response;
        })
        .catch((error) => {
          console.error('Error:', error);
       });
//       }).catch((error) => {
//           console.error('Error:', error);
//       });
    }

    return false;
  }
  cartClear(){
     var config = this.getDefaultRequestConfig();
      config.method = 'POST';
     return this.fetchJSON('/cart/clear.js', config);
  }
  cartAddFromForm(formData) {
 
  var config = this.getDefaultRequestConfig();
//   delete config.headers['Content-Type'];

  config.method = 'POST';
  config.body = JSON.stringify(formData);

  return this.fetchJSON('/cart/add.js', config);
}
  prepareVariantData(){
   	  let self=this;
    let roots = this.product.variants.map(function(item) {
      var key=item.option2_handle+'-'+item.option1_handle;
      // var price=item.price-18000;
      var price=item.price;
      item['savedAmount']=item.compare_at_price>0?item.compare_at_price-price:0;
      item['percentage']=item.compare_at_price>0?Math.ceil(((item['savedAmount'])*100)/item.compare_at_price):0;
     	  self.variants[key]=item;
      return item;
    });  
    //console.log(self.variants);
  }
   fetchJSON(url, config) {
    return fetch(url, config).then(function(response) {
      if (!response.ok) {
        throw response;
      }
      return response.json();
    });
  }
  cart() {
    return this.fetchJSON('/cart.js', this.getDefaultRequestConfig());
  }
  getDefaultRequestConfig() {
    return JSON.parse(
      JSON.stringify({
        credentials: 'same-origin',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'application/json;'
        }
      })
    );
  }
  onChangeMealtype(){   
   var str='';
    $.each($(this.formselector).find("input[name='data-mealtype[]']:checked"), function(){
        str+=" + "+$(this).val();
    });
    str = str.substring(3);
    this.mealtypes=str;
    this.selectVariant();
  }
  getVariantBaseValue(item){
  		if (item.option1==this.mealday&&item.option2==this.mealday) {
        return item.id;
      }
    return false;
  }
  onChangeDay(){
    var howmanyday=$(this.formselector).find("input[name='properties[Which days of the week?]']:checked").data('value');
    if(howmanyday==5&&(parseInt(this.mealday)==6||parseInt(this.mealday)==7)){
//   		  $(this.formselector).find('input[name="properties[How many days a week?]"][value="' + parseInt(this.mealday) + ' Days"]').prop('checked', true);
    	this.onChangeDays();
    }
    $(this.formselector).find(".mealday").html($(this.formselector).find("input[name='properties[Which days of the week?]']:checked").val());
  }
  
   onChangeDays(){
     $(this.formselector).find(".mealdays #meal_days").html($(this.formselector).find("input[name='days']:checked").data('text')); 
     $(this.formselector).find(".addon_products .addonDays").html($(this.formselector).find("input[name='days']:checked").data('text')); 
    this.updatePriceValues();
      
    
     
     this.mealday = $(this.formselector).find("input[name='days']:checked").val();
     var howmanyday=$(this.formselector).find("input[name='properties[Which days of the week?]']:checked").data('value');
//     if(parseInt(this.mealday)<=howmanyday){
//       this.onChangeDay();
//     }
     if(howmanyday==5&&(parseInt(this.mealday)==6||parseInt(this.mealday)==7)){
       $(this.formselector).find('input[name="days"][value="5 Days"]').prop('checked', true);
       this.mealday = $(this.formselector).find("input[name='days']:checked").val();
       $(this.formselector).find(".mealdays #meal_days").html($(this.formselector).find("input[name='days']:checked").data('text'));
     }
        this.selectVariant();
//      }
  }
  selectVariant(){
    let self=this;     
    let key= this.mealday.replace(/\W+/g, "-").toLowerCase()+'-'+this.mealtypes.replace(/\W+/g, "-").toLowerCase();
    //console.log(key);
    $(".mealtypeerror").hide();
    $("#Option--0").val(this.mealtypes);
    $("#Option--1").val(this.mealday);    
    this.variant=false;
    if(self.mealday!='' && self.mealtypes!=''){
        //       let roots = this.product.variants.map(function(item) {
        // // 		console.log(item);
        //           if (item.option1==self.mealday&&item.option2==self.mealtypes) {
        //            return self.variant=item;
        //         }
        //         return item;
        //       });
      self.variant = self.variants[key];
    }
    //console.log(this.mealtypes);    
    $(this.formselector).find(".mealdays #meal_type").html(this.mealtypes);
    
    //console.log('self variant');
    //console.log(self.variants);
    //console.log(self.variant.id);

    

    
    if(self.variant){
      $("#button-"+this.product.id).prop('disabled',false);      
      $("#stricky-button-"+this.product.id).prop('disabled',false);
      $("#productvariant-"+this.product.id).val(self.variant.id); 
      $("#Option--0").val(this.mealtypes);
      $("#Option--1").val(this.mealday); 
      this.updatePriceValues();
      this.oldmealtype = this.mealtypes;
      $(".total-sec").show();
    }else{
      $(".mealtypeerror").find('strong').html(this.mealtypes);
      $(".mealtypeerror").show();
      $(".total-sec").hide();
      //$(this.formselector).find(".mealtotal").html(this.formatMoney(0,'amount_no_decimals'));
      $("#button-"+this.product.id).prop('disabled',true);
      $("#stricky-button-"+this.product.id).prop('disabled',true);
    }	
  }
  // Event binding is already done:

  
  
  updateAddonProducts() {
      var self = this;
      var addprice = 0;
      var formattedAddPrice = 0;
      var formattedPrice = 0;
      var subTotalPrice = 0;
      var formattedSubTotalPrice = 0;
      var addonitems = [];  // Array to store all the addon items data
      var addpTitle = 'None';   
      $(".meal_days.addoncontainer").empty();
    
      // Iterate over all checked checkboxes
      $(self.formselector).find("input:checkbox[name='addon_productid[]']:checked").each(function() {
          var checkbox = $(this); // Current checked checkbox
  
          // Find the parent div (salad_container) for this checkbox
          var parentDiv = checkbox.closest('.salad_container'); 
          
          // Get the class ID value from the parent div (addon_1, addon_2, etc.)
          var classIdValue = parentDiv.data('classid');
          
          // Log the class ID (this is where each addon is identified)
          //console.log('Class ID:', classIdValue);
  
          // Find the hidden input inside the same parent div
          var hiddenInput = parentDiv.find('input[type="hidden"]');
          
          // Get the hidden input data
          var productId = hiddenInput.data('product_id');
          var price = hiddenInput.data('price');
          formattedPrice = (price / 100).toFixed(2) + ' AED';          
          var addonId = hiddenInput.data('id');
          var hiddenInputValue = hiddenInput.val();          
          addprice=price*parseInt(self.mealday);
          formattedAddPrice = (addprice / 100).toFixed(2) + ' AED';          
          addpTitle=checkbox.data('title'); 
        // console.info('hiddenInputValue');
        // console.info(self.mealday);
        //   console.info(price);
        // console.info(hiddenInputValue);
        // console.info(formattedAddPrice);
          // Log the details for this checked checkbox's hidden input
          /*console.log('Product Title:', addpTitle);
          console.log('Product ID:', productId);
          console.log('Price:', price);
          console.log('Addon ID:', addonId);
          console.log('Hidden Input Value:', hiddenInputValue);*/
          
          // Add the addon price to the total price
          subTotalPrice += addprice; // Add the price of the current addon
          /*console.log('Sub Total:', subTotalPrice);*/

          var addonHtml = '<div class="addon_list addon_2"><div class="addon_products"><span class="bodyreg font-weight-medium caption_color">Add On: <span class="bodyreg font-weight-medium caption_color" id="'+classIdValue+'Name">'+addpTitle+'</span></span><span class="bodyreg-sm font-weight-normal caption_color">(<span class="bodyreg-sm font-weight-normal caption_color" id="'+classIdValue+'addonPrice">'+formattedPrice+'</span> x <span class="addonDays bodyreg-sm font-weight-normal caption_color">'+self.mealday+'</span>)</span></div><div class="mealprice" id="'+classIdValue+'addonPrice"><span id="'+classIdValue+'price" class="bodyreg font-weight-medium heading_color">'+formattedAddPrice+'</span></div></div>';
          $(this.formselector).find("#"+classIdValue+"price").html(formattedPrice);     
          $(".meal_days.addoncontainer").append(addonHtml);
  
          // Store the details in the addonitems array
          addonitems.push({
              classId: classIdValue,
              productId: productId,
              price: price,
              addonId: addonId,
              hiddenInputValue: hiddenInputValue,
              subTotal:subTotalPrice
          });
      });
  
      // After processing, you can use or log addonitems array for further actions
      console.log('Addon items:', addonitems);
      
  }
  updatePriceValues(){
     var self=this;
     var discountval = 0;
     var savedAmount = 0;
     var addprice=0;
     var bagPrice =0;
     var tabbyaddprice=0;
     var addsavedAmount=0;
     var addcompareprice=0;
     var formattedPrice=0;
     var addpTitle='None';   
     var addpactualPrice = 0;
     var subTotalPrice = 0;
    
    
    $(this.formselector).find(".mealtotal").html(this.formatMoney(this.variant.price,'amount_no_decimals'));
    $(this.formselector).find("#subtotal").html(this.formatMoney(this.variant.price,'amount_no_decimals'));
    $(this.formselector).find("#meal_price").html(this.formatMoney(this.variant.price,'amount_no_decimals'));
    
    this.updateAddons();
    if(!this.variant.compare_at_price){   
       $(this.formselector).find(".was-price").hide();
       $(this.formselector).find(".savedmsg").hide();
      
      if($(this.formselector).find('#related-item-'+this.product.id)!=undefined){   
        $(self.formselector).find("input:checkbox[name='addon_productid[]']:checked").each(function() {  


          var checkbox = $(this); // Current checked checkbox
  
          // Find the parent div (salad_container) for this checkbox
          var parentDiv = checkbox.closest('.salad_container'); 
          
          // Get the class ID value from the parent div (addon_1, addon_2, etc.)
          var classIdValue = parentDiv.data('classid');
          
          // Log the class ID (this is where each addon is identified)
          console.log('Class ID:', classIdValue);
        
          var addp=self.getAddonPrice($(this).data('product_id'));  
          console.info(addp);
          addpTitle=$(this).data('title'); 
          var addpactualPrice = addp.price;
          addprice=addprice+(addp.price*parseInt(self.mealday));
          
          subTotalPrice = subTotalPrice+addprice;
         
          formattedPrice = (addprice / 100).toFixed(2) + ' AED';
          $(self.formselector).find('#'+classIdValue+'price').html(((addp.price*parseInt(self.mealday))/ 100).toFixed(2) + ' AED');
          console.info($(self.formselector).find('#'+classIdValue+'price'));
          console.log("formattedPrice"+formattedPrice+" "+classIdValue+" and "+ "#"+classIdValue+"price");
          console.log($(this.formselector).find("#"+classIdValue+"price"));
          //console.log($(this.formselector).find("#addonName"));
         // $(this.formselector).find("#"+classIdValue+"Name").html(addpTitle);
          $(this.formselector).find("#"+classIdValue+"price").html(formattedPrice);         
        });        
       
      }
      
       
      
    }else{
//        savedAmount = this.variant.compare_at_price-this.variant.price;
//        discountval= (((savedAmount)*100)/this.variant.compare_at_price)*100;
     console.log('test3');
      if($(this.formselector).find('#related-item-'+this.product.id)!=undefined){
        console.log('test4');
        	$(this.formselector).find('#related-item-'+this.product.id).find("input:checkbox[name='addon_productid[]']:checked").each(function(){
              var addp=self.getAddonPrice($(this).data('product_id'));
              addprice=addprice+(addp.price*parseInt(self.mealday));
              var addpt=self.getAddonPrice($(this).data('product_id'),false);
              tabbyaddprice=tabbyaddprice+(addpt.price*parseInt(self.mealday));
              addcompareprice=addcompareprice+(addp.compare_at_price*parseInt(self.mealday));
              addsavedAmount=addsavedAmount+((addp.compare_at_price>0?addp.compare_at_price-addp.price:0)*parseInt(self.mealday));
              
            });
      }
      if(Math.round(this.variant.percentage)>0){
         $(this.formselector).find(".was-price").show();
         $(this.formselector).find(".savedmsg").show();
      }else{
        $(this.formselector).find(".was-price").hide();
         $(this.formselector).find(".savedmsg").hide();
      }
      
       
       $(this.formselector).find(".was-price").html(this.formatMoney(this.variant.compare_at_price+addcompareprice,'amount_no_decimals'));
      //console.log(this.variant.option2);
      /*if(this.isFreeBreakfast=='true'&& (this.variant.option2=='Breakfast + Lunch + Dinner + x2 Snacks' || this.variant.option2=='Breakfast + Lunch + Dinner' || this.variant.option2=='Breakfast + Lunch + Dinner + Green Smoothie'|| this.variant.option2=='Breakfast + Lunch + Dinner + PCOS Seed Cycling')){
          $(this.formselector).find(".amountpercentage").html('Free Breakfast - ');
      }else{
        $(this.formselector).find(".amountpercentage").html(Math.round(this.variant.percentage)+'%');
      }*/
       
       $(this.formselector).find(".amountsaved").html(this.formatMoney(this.variant.savedAmount+addsavedAmount,'amount_no_decimals'));
    }
    
    
    if($(this.formselector).find('#bag-deposit-'+this.product.id).length>0){
      //console.log('Bag Price');
      //console.log($(this.formselector).find('#bag-deposit-'+this.product.id));
        let bagInput = $(this.formselector).find('#bag-deposit-'+this.product.id).find('input:checkbox[name=bag_deposit]:checked');
      //console.log('bagInput');
        bagPrice=(parseInt(bagInput.val())!=0 )?parseInt(bagInput.data('price')):0;
      if(isNaN(bagPrice)){
        bagPrice = 0;
      }
       // bagPrice>0?$("#bag_price_msg").show():$("#bag_price_msg").hide();
     }
    //$(this.formselector).find(".actual-price").html(this.formatMoney(this.variant.price-18000+addprice,'amount_no_decimals'));
    $(this.formselector).find(".actual-price").html(this.formatMoney(this.variant.price+addprice,'amount_no_decimals'));
    //console.log("bagPrice => "+bagPrice);
    $(this.formselector).find(".mealtotal").html(this.formatMoney(this.variant.price+addprice+bagPrice,'amount_no_decimals'));
    //console.log("subTotalPrice => "+subTotalPrice);
    //console.log("this.variant.price => "+this.variant.price);
    $(this.formselector).find("#subtotal").html(this.formatMoney(this.variant.price+addprice,'amount_no_decimals'));
    $(this.formselector).find(".actual-price-tabby").html(this.formatMoney(this.variant.compare_at_price+tabbyaddprice,'amount_no_decimals'));
    var tabbyprice = (Math.round(this.variant.percentage)>0)?this.variant.compare_at_price+18000:this.variant.compare_at_price+18000;
    $(this.formselector).find(".totalprice-tabby").html(this.formatMoney(tabbyprice+tabbyaddprice,'amount_no_decimals'));
    this.showDiscountPercentage();
  }
  showDiscountPercentage(){
    let self=this;
    if($(this.formselector).find(".switch-meal-days").length>0){
      	$(this.formselector).find(".switch-meal-days").each(function() {
          var key = $(this).find('input').val().replace(/\W+/g, "-").toLowerCase()+'-'+self.mealtypes.replace(/\W+/g, "-").toLowerCase();
  //        console.log(key);
 //          console.log(self.variants[key]);
          if(self.variants[key].percentage>0){
            //console.log(self.variants[key].percentage);
            $(this).removeClass('no-off');
            //console.log(self.variant.option2);
            /*if(self.isFreeBreakfast=='true' && (self.variant.option2=='Breakfast + Lunch + Dinner + x2 Snacks' || self.variant.option2=='Breakfast + Lunch + Dinner' || self.variant.option2=='Breakfast + Lunch + Dinner + Green Smoothie' || self.variant.option2=='Breakfast + Lunch + Dinner + PCOS Seed Cycling')){
              $(this).find('.upto').show(); 
              $(this).find('.upto').html('Free <span class="text-span">Breakfast</span>');
            }else{
                  $(this).find('.upto').show(); 
                  $(this).find('.upto').html('Up to <span class="text-span">'+self.variants[key].percentage+'% off</span>');
            }*/
          
          }else{
             $(this).addClass('no-off');
             $(this).find('.upto').hide();
          }
        });
    }
    
  }
  getAddonPrice(id){ //,withdiscount=true  
    if($("#productjson-"+id)!=undefined){
    var addonProduct=JSON.parse($("#productjson-"+id).html());
       //console.log(addonProduct);
      if(addonProduct.variants!=undefined){
        if(Object.keys(addonProduct.variants).length>1){
            for (let key in addonProduct.variants) {
               if (addonProduct.variants.hasOwnProperty(key)) {
      //             console.log(addonProduct.variants[key]);
      //             console.log(this.variant.percentage);

                 if(parseInt(addonProduct.variants[key].title)==this.variant.percentage && withdiscount){
                   return addonProduct.variants[key];
                 }else if(this.variant.percentage==0 || !withdiscount){
                   return addonProduct.variants[key];
                 }
               }
             }
        }else{
          return addonProduct.variants[0];
        }
      }else{
        return addonProduct.price;
      }
    }
  }
  updateAddons(){
    let self=this;
   if($(this.formselector).find('#related-item-'+this.product.id)!=undefined){
      $(this.formselector).find('#related-item-'+this.product.id).find('.addonDays').text(parseInt(this.mealday));
      $(this.formselector).find('#related-item-'+this.product.id).find('.addon-quantity').val(parseInt(this.mealday));
      $(this.formselector).find('#related-item-'+this.product.id).find('.addon-quantity').each(function(){
        var addprice=self.getAddonPrice($(this).data('product_id'));
        console.info("addon products");
        console.info(addprice);
        if(addprice!=undefined){
          $(this).data('id',addprice.id);
          $(this).data('price',addprice.price);
          $('#addon-label-'+$(this).data('product_id')+' .addon-price').text(self.formatMoney(addprice.price)); 
          $('#addon-'+$(this).data('product_id')).val(addprice.id);
          $('#addon-total-'+$(this).data('product_id')).find('b').text(self.formatMoney($(this).data('price')*$(this).val()));
        }
        
      });
    } 
  }
   formatWithDelimiters(number) {
    var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    var thousands = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ',';
    var decimal = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '.';

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.');
    var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var centsAmount = parts[1] ? decimal + parts[1] : '';

    return dollarsAmount + centsAmount;
  }
  formatMoney(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString =  this.moneyFormat;
  
  

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = this.formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = this.formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = this.formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = this.formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
}
  
}